module.exports = __webpack_public_path__ + "static/media/loyalty_account_number.2833eefa.png";